import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classnames from 'classnames';

import { withSearchHandler } from 'decorators';
import { buildStartHereLink } from 'lib/search';

import { Container } from 'components/core/Page';
import { HH } from 'components/core/Headline';
import { Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { SearchBox } from 'components/search/SearchBox';
import { StickySearchBar } from 'components/landing/StickySearchBar';

import { STATE_HERO_IMAGES } from './stateHeroImages';

import './SLPHero.scss';

const withComputedProps = (Component) => (props) => {
	const searchLocation = props.searchLocation || {};
	const { state, stateCode } = searchLocation;

	const queryParams = get(props, 'queryParams');

	const additionalSearchParams = {
		informedSearch: true,
		state: stateCode || state,
	};

	const searchLinkParams = {
		...(state ? { state } : {}),
		...(stateCode ? { stateCode } : {}),
		informedSearch: true,
		...queryParams,
	};

	return (
		<Component
			{...props}
			additionalSearchParams={additionalSearchParams}
			startHereLink={buildStartHereLink(searchLinkParams)}
		/>
	);
};

export const enhance = (Component) =>
	withComputedProps(withSearchHandler(Component));

export function SLPHero({
	searchLocation = {},
	handleSearch,
	startHereLink,
	headline,
	subtitle,
	className,
	heroMapImage,
}) {
	const { city, state, stateCode } = searchLocation;
	const stateClassName = stateCode
		? `slp-hero--state-${stateCode.toLowerCase()}`
		: null;

	const resolvedHeroImage =
		heroMapImage || (stateCode && STATE_HERO_IMAGES[stateCode]) || null;

	const locationLabel = city || state || 'your area';

	const resolvedSubtitle = subtitle || 'Make a free reservation in minutes!';

	const heroStyle = {
		...(resolvedHeroImage
			? { '--slp-hero-bg': `url(${resolvedHeroImage})` }
			: {}),
	};

	return (
		<div
			className={classnames('slp-hero', className, stateClassName, {
				'slp-hero--has-bg': Boolean(resolvedHeroImage),
			})}
			data-state-code={stateCode || undefined}
			style={heroStyle}
		>
			<div className="slp-hero__inner">
				<div className="slp-hero__card">
					<HH className="slp-hero__title">
						Find storage near you in <br />
						{state}
					</HH>
					<Paragraph
						className="slp-hero__subtitle"
						color="gray"
					>
						{resolvedSubtitle}
					</Paragraph>

					<SearchBox
						id="slp-sticky-search"
						inputLabel="Enter address, city, or zip"
						handleSearch={handleSearch}
						buttonText="Find storage"
						slpPinkButton={true}
						className="slp-hero__search"
					/>
				</div>
			</div>
		</div>
	);
}

SLPHero.propTypes = {
	searchLocation: PropTypes.shape({
		state: PropTypes.string,
		stateCode: PropTypes.string,
		city: PropTypes.string,
	}),
	handleSearch: PropTypes.func,
	startHereLink: PropTypes.string.isRequired,
	headline: PropTypes.string,
	subtitle: PropTypes.string,
	className: PropTypes.string,
	heroMapImage: PropTypes.string,
};

export default enhance(SLPHero);
